import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import RegisterForm from './pages/forms/RegisterForm';
import LoginForm from './pages/forms/LoginForm';
import FichajeForm from './pages/empleado/FichajeForm';
import Home from './pages/Index';
import Layout from './layout/Layout';
import ProtectedRoute from './context/ProtectedRoute';
import PublicRoute from './context/PublicRoute'; // <-- añadido

// 404 page
import NotFound from './layout/404';
import Informes from './pages/admin/Informes';
// 🔹 Admin
import AdminLayout from './layout/AdminLayout';
import Empresa from './pages/admin/Empresa';
import Empleados from './pages/admin/Empleados';
import Fichajes from './pages/admin/Fichajes';
import FichajeFormAdmin from './pages/admin/FichajeFormAdmin';
import Subscribe from './components/Subscribe';
import IncidenciasAdmin from './pages/admin/Incidencias';
import DashboardAdmin from './pages/admin/DashboardAdmin';
// 🔹 Empleado
import EmpleadoLayout from './layout/EmpleadoLayout';
import FichajeFormEmpleado from './pages/empleado/FichajeForm';
import EditarPerfil from './pages/empleado/EditarPerfil';
import IncidenciasEmpleado from './pages/empleado/IncidenciasEmpleado'; // <-- NUEVO
import DashboardEmpleado from './pages/empleado/DashboardEmpleado';
import ResetPassword from './pages/forms/ResetPassword';
import ResetPasswordConfirm from './pages/forms/ResetPasswordConfirm';
import Docs from './pages/docs/Docs';

// Listados de informes
import ListadoHorasT from './pages/admin/ListadoHorasT';
import ListadoIncidenciasT from './pages/admin/ListadoIncidenciasT';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Layout general */}
        <Route path="/" element={<Layout />}>
          <Route 
            index 
            element={
              <PublicRoute>
                <LoginForm />
              </PublicRoute>
            } 
          />

          <Route
            path="docs"
            element={
              <PublicRoute>
                <Docs />
              </PublicRoute>
            }
          />    

          <Route 
            path="reset-password" 
            element={
              <PublicRoute>
                <ResetPassword/>
              </PublicRoute>
            } 
          />

          <Route 
            path="reset-password/confirm" 
            element={
              <PublicRoute>
                <ResetPasswordConfirm />
              </PublicRoute>
            } 
          />

          <Route 
            path="register" 
            element={
              <PublicRoute>
                <RegisterForm />
              </PublicRoute>
            } 
          />
        </Route>


        {/* Panel de administrador */}
        <Route 
          path="/admin" 
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <AdminLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardAdmin />} />
          <Route path="empresa" element={<Empresa />} />
          <Route path="empleados" element={<Empleados />} />
          <Route path="fichajes" element={<Fichajes />} />
          <Route path="fichar" element={<FichajeFormAdmin />} />
          <Route path="informes" element={<Informes />} />  {/* <-- NUEVO */}
          <Route path="informes/listadohoras" element={<ListadoHorasT />} />  {/* <-- NUEVO */}
          <Route path='informes/listadoincidencias' element={<ListadoIncidenciasT />} />  {/* <-- NUEVO */}
          {/* <Route path="subscribe" element={<Subscribe />} /> */}
          <Route path="incidencias" element={<IncidenciasAdmin />} />  {/* <-- NUEVO */}
        </Route>

        {/* Panel de empleado */}
        <Route
          path="/empleados"
          element={
            <ProtectedRoute allowedRoles={['empleado']}>
              <EmpleadoLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="fichar" replace />} />
          {/* <Route path='dashboard' element={<DashboardEmpleado />} /> */}
          <Route path="perfil" element={<EditarPerfil />} />
          <Route path="fichar" element={<FichajeFormEmpleado />} />
          <Route path="incidencias" element={<IncidenciasEmpleado />} /> {/* <-- NUEVO */}
        </Route>
        {/* 404 */}
        <Route path="*" element={<NotFound />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
